import { observer } from 'mobx-react-lite';
import React, { useRef, useState, useId } from 'react';

import { Icon, IconBus } from '@flixbus/honeycomb-icons-react';
import { Tag, Tooltip, useSmartPosition } from '@flixbus/honeycomb-react';

import { NA_LABEL } from 'pages/RideListPage/const';

import { buildVehicleTagData } from './buildVehicleTagData';

import styles from './styles.module.css';

const VehicleAssignmentTag = observer(
	({ vehicleAssignment = {}, icon = IconBus, fallbackLabel = NA_LABEL }) => {
		const targetRef = useRef();
		const balloonRef = useRef();
		const [isTooltipActive, setIsTooltipActive] = useState(false);
		const id = useId();

		const [smartPosition, smartAlignment] = useSmartPosition({
			active: isTooltipActive,
			targetRef,
			elementRef: balloonRef,
		});

		const { tooltipContent, busLabel } = buildVehicleTagData({
			vehicleAssignment,
			fallbackLabel,
		});

		return (
			<Tooltip
				id={id}
				content={tooltipContent}
				innerRef={targetRef}
				balloonRef={balloonRef}
				openOnHover
				position={smartPosition}
				alignment={smartAlignment}
				onToggle={setIsTooltipActive}
			>
				<Tag display="outlined" extraClasses={styles.vehicleTag}>
					<Icon size={3} InlineIcon={icon} />
					{busLabel}
				</Tag>
			</Tooltip>
		);
	}
);

export default VehicleAssignmentTag;
